var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$vuetify.breakpoint.mdAndUp)?_c('div',{style:({
    padding: '0 24px 0 24px',
    minHeight: '100vh',

    backgroundColor:
      _vm.entity.map &&
      _vm.entity.map.blackBackground 
        ? '#000000'
        : '',

    backgroundImage:
      _vm.entity.backgroundImage
        ? 'url(' + _vm.entity.backgroundImage + ')'
        : (
            _vm.entity.map &&
            _vm.entity.map.blackBackground
              ? 'none'
              : 'url(https://duonz.s3-ap-southeast-2.amazonaws.com/image/background/BDM.Map.BG.jpg)'
          ),

    backgroundSize: 'cover',
    margin: 0
  })},[_c('duo-landing-page',{attrs:{"show":_vm.loaded,"entity":_vm.entity,"question-map":_vm.entity.transitMap.questionMap,"submitted-map":_vm.entity.transitMap.submittedMap},on:{"onReset":function($event){return _vm.getData()}}})],1):_c('landing-page-view-mobile')
}
var staticRenderFns = []

export { render, staticRenderFns }